module.exports = __webpack_public_path__ + "img/TradingView-icon2.115db50e.svg";